import { queryThirdPartyMappingList, queryListByChannelDataType } from '@/api/basicData/thirdPartyMapping'

/**
 * 第三方平台通道数据缓存工具类
 */
export class ThirdPartyMappingUtil {
  // 实例集合
  static instanceMap = new Map()
  constructor() {
    this._map = {}
  }
  get map() {
    return this._map
  }
  set map(value) {
    this._map = value
  }
  static async getInstance(platformChannelCode) {
    const instance = this.instanceMap.get(platformChannelCode)
    if (instance) {
      return instance
    }
    const newInstance = new ThirdPartyMappingUtil()
    this.instanceMap.set({ platformChannelCode }, newInstance)
    await queryThirdPartyMappingList({ platformChannelCode: platformChannelCode }).then(async(res) => {
      const source = res.data
      if (!source) return
      const map = {}
      source.forEach(obj => {
        if (!map.hasOwnProperty(obj.dataType)) {
          map[obj.dataType] = []
        }
        map[obj.dataType].push(obj)
      })
      newInstance.map = map
    })
    return newInstance
  }
  getListByDataType(dataType) {
    return this.map[dataType]
  }
  getListByDataTypeCarrierCode(dataType, carrierCode) {
    const allList = this.map[dataType]
    const carrierCodes = []
    const notCarrierCodes = []
    if (allList && allList.length > 0) {
      for (const item of allList) {
        if (!carrierCode && !item.carrierCode) {
          notCarrierCodes.push(item)
        }
        if (carrierCode && item.carrierCode === carrierCode) {
          carrierCodes.push(item)
        }
      }
    }
    return (carrierCode ? carrierCodes : notCarrierCodes) || []
  }
  async getListByChannelDataType(channelCode, dataType) {
    if (!this.map[dataType] || this.map[dataType].length <= 0) {
      await queryListByChannelDataType({ platformChannelCode: channelCode, dataType: dataType }).then(res => {
        const obj = res.data
        if (!obj) return
        this.map['seaport'] = obj['seaport']
        this.map['ooclSeaport'] = obj['ooclSeaport']
        return this.map[dataType]
      })
    }
    return this.map[dataType]
  }
  static getPackageCode(packages, value) {
    if (!packages || packages.length === 0) {
      return ''
    }
    for (const data of packages) {
      if (data.code === value || data.name === value) {
        return data.code
      }
    }
    return ''
  }
}
